import React, {useState} from 'react';
import styles from './styles';
import {Form, SuccessSvg, ErrorSvg} from '@xpertdox_js/xdcomponents';
import sendFeedback from './sendFeedback';
import {UserContext} from '../../Context/UserContext';
import axios from "axios";
import axiosConfig from "../../config/axios.config";

const FeedbackForm = props => {
  const {user} = React.useContext(UserContext)
  const [admins, setAdmins] = React.useState(null)
  const [result, setResult] = useState(null);
  const [formInput, setFormInput] = useState({})

  if (!admins && props.match && props.match.params.instance) axios.get(`${axiosConfig.apiUrl}/rt/fetchAdmins/${props.match.params.instance}`)
    .then(result => setAdmins(result.data))
    .catch(err =>console.log(err))

  const settings = [
    {
      label: 'Please select the nature of this message.',
      labelStyles: {paddingBottom: '32px'},
      type: 'select',
      options: [
        [`Content Feedback (Any issues with content being displayed will be relayed to ${props.match.params.instance})`, 'cnt_fb'],
        ['Technical Feedback (Any platform related issues will be relayed to XpertDox)', 'tech_fb']
      ],
      id: 'feedback_type',
    },
  ];

  if (formInput.feedback_type !== '') settings.push({
      label: 'Return email',
      placeholder: 'Return email',
      type: 'email',
      id: 'email',
      styles: styles.textInput,
    },{
      label: 'Feedback Subject',
      placeholder: 'Feedback Subject',
      type: 'text',
      id: 'subject',
      notRequired: true,
      styles: styles.textInput,
    },{
      type: 'radio',
      label: 'Where did this issue occur?',
      id: 'bug_location',
      options: [['Patients Tab', 'pat_loc'], ['Trials Tab', 'trial_loc'], ['Survey Tab', 'survey_loc'], ['Users Tab', 'user_loc'], ['Other', 'othr_loc']]
    }
  )

  if (formInput.bug_location === 'othr_loc') settings.push({
    label: 'Briefly describe where this issue ocurred.',
    placeholder: 'Description of bug location',
    type: 'text',
    id: 'otherLocation',
    notRequired: true,
    styles: styles.textInput,
  })
  if (formInput.feedback_type !== '') settings.push({
    label:  'Please explain the nature of your problem and, if you can, explain the steps we can follow to reproduce the problem.',
    placeholder: 'Message',
    type: 'textarea',
    id: 'message',
    styles: styles.textInput,
  })

  const handleSubmit = async () => {
    const res = await sendFeedback({
      email: formInput.email && formInput.email !== '' ? formInput.email : user.email,
      subject: formInput.subject,
      message: formInput.message,
      type: formInput.feedback_type,
      location: formInput.bug_location,
      otherLocation: formInput.otherLocation,
    });
    setResult(res)
  }

  const svgProps = {
    fontSize: '25px',
    width: '20%'
  }

  return(
    <div style={styles.container}>
      <div style={styles.formDescription}>
        <h2 style={styles.title}>Give us your feedback!</h2>
        <p style={styles.description}>Use the form below to reach out to us with any feedback about the application you have or features you would like to see added in future updates.</p>
        <p style={styles.description}>If you are experiencing bugs or errors in your application please reach out to with us with a bug report and we will get right on it.</p>
      </div>
      <div style={styles.formWrap}>
        {result === null
          ? <Form
              settings={settings}
              handleSubmit={handleSubmit}
              submitable={formInput.feedback_type !== ''}
              memo={formInput.feedback_type + formInput.bug_location}
              state={{
                formState: formInput,
                setFormState: setFormInput,
              }}
            />
          : result === true
          ? <SuccessSvg
              text={'Message Sent.'}
              {...svgProps}
            />
          : <ErrorSvg
              text={'Error Sending Message.'}
              {...svgProps}
            />
        }
      </div>
      {admins && <div style={styles.emergencyBox}>
        <p style={styles.emergencyText}><b>For any urgent issues contact</b></p>
        <ul style={styles.emergencyList}>
          {admins.map(admin => <React.Fragment key={admin.name}>
            <li style={{marginBottom: 5, fontSize: '1.6rem'}}><b>{admin.name}  </b>{admin.email}</li>
          </React.Fragment>)
          }
        </ul>
      </div>}
    </div>
  )

}

export default FeedbackForm;
